/* eslint-disable react/no-unknown-property */
import { SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import { Ardbeg, GiveAway } from '../MainBanner/January2025Sliders';
import {
  ChristmasSecondSlider,
  ChristmasFourthSlider,
  ChristmasFifthSlider,
} from '../MainBanner/ChristmasSliders';
import { IndexBannerSliderProps } from '@/types';
import CommonSwiper from '@/components/common/CommonSwiper';
import {
  BottlesOfTheMonthMainBannerApril2025,
  BowmoreSelectionMainBannerApril2025,
} from '../MainBanner/April2025Sliders';

export default function IndexBannerSlider({ userId }: IndexBannerSliderProps) {
  return (
    <>
      <h1 className="sr-only">
        Find your whisky on the leading marketplace for premium spirits - Spiritory
      </h1>
      <style jsx>{`
        :global(.swiper-pagination-bullet) {
          width: 25px;
          aspect-ratio: 16/9;
          border-radius: 10px;
        }

        :global(.swiper-pagination-bullet-active) {
          background-color: #15253f;
          transform: scale(1.2);
          opacity: 1;
        }

        :global(.swiper-pagination) {
          padding-top: 30px;
          padding-bottom: 20px;
          position: relative;
          display: flex;
          justify-content: center;
          gap: 8px;
        }
      `}</style>
      <CommonSwiper
        slidesPerView={1}
        autoplay={{
          delay: 5000,
        }}
        loop={true}
        spaceBetween={25}
        modules={[Pagination, Autoplay]}
        pagination={{ clickable: true }}
        className="tw-h-fit max-nine:!tw-w-full"
      >
        <SwiperSlide>
          <BowmoreSelectionMainBannerApril2025 />
        </SwiperSlide>
        <SwiperSlide>
          <BottlesOfTheMonthMainBannerApril2025 />
        </SwiperSlide>
        <SwiperSlide>
          <Ardbeg />
        </SwiperSlide>
        <SwiperSlide>
          <ChristmasFifthSlider />
        </SwiperSlide>
        <SwiperSlide>
          <ChristmasFourthSlider />
        </SwiperSlide>
        <SwiperSlide>
          <ChristmasSecondSlider userId={userId} />
        </SwiperSlide>
      </CommonSwiper>
    </>
  );
}
